import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  CtButtonConfiguration,
  CtControlService,
  CtControlTypes,
  CtFormConfiguration,
  CtSelectControlOptions,
  CtSelectControlValue, CtTextareaControlOptions,
  CtThemeTypes,
  MAT_RAISED_ACCENT,
  MAT_RAISED_WARN,
  MateriaHintExtensionConfig,
  MaterialControlOptions
} from "@ctsolution/ct-framework";
import { FormBuilder } from "@angular/forms";
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from "@angular/material/legacy-dialog";
import { MovementManagerAddItemConfiguration } from "./movement-manager-add-item.configuration";
import { CtWorkOrderRowItem } from "../../../../../../../_core/classes/ct-work-order.row-item";
import { CTWorkOrderRow } from "../../../../../../../_core/classes/ct-work-order.row";
import { CtWorkOrderRowOffer } from "../../../../../../../_core/classes/ct-work-order.row-offer";
import { CtWorkOrderRowContact } from "../../../../../../../_core/classes/ct-work-order.row-contact";
import { CTWorkOrderRowUnionType } from "../../../../../../../_core/classes/ct-work-order.row-union";
import { CTMGeneralService } from 'projects/ct-manager/src/app/_core/lib/general.service';
import { WorkOrderService } from '../../../../../work-order.service';
import { WorkOrderRowState } from "../../../../../../../_core/enum/work-order-row-state";
import { WorkOrderRowOrigin } from "../../../../../../../_core/enum/work-order-row-origin";
import { CtManagerService } from 'projects/ct-manager/src/app/_core/lib/ct-manager.service';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { CTManagerItem } from 'projects/ct-manager/src/app/_core/classes/ct-manager-item';

@Component({
  selector: 'app-movement-manager-add-item',
  templateUrl: './movement-manager-add-item.component.html',
  styleUrls: ['./movement-manager-add-item.component.scss'],
  providers: [WorkOrderService]
})
export class MovementManagerAddItemComponent implements OnInit {

  formConfiguration: CtFormConfiguration | null = null;

  cancelButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("close")
    .setAction(() => this.onCancel())
    .setMatherialOptions(MAT_RAISED_WARN);

  addButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => this.onAdd())
    .setMatherialOptions(MAT_RAISED_ACCENT);

  private vatControl = this.generalService.getTextControl({
    name: 'VAT',
    required: false,
    flexSpacePercentage: 50
  }).setType(CtControlTypes.ENUMERABLE)
    .setLabel('IVA (%)')
    .setValueOptions([
      CtSelectControlValue.create().setLabel("(Nessuno)").setValue(null),
      CtSelectControlValue.create().setLabel("4").setValue(4),
      CtSelectControlValue.create().setLabel("10").setValue(10),
      CtSelectControlValue.create().setLabel("22").setValue(22),
    ])

  private discountControl = this.generalService.getTextControl({
    name: 'Discount',
    required: false,
    flexSpacePercentage: 50
  }).setType(CtControlTypes.NUMBER)
    .setValue(0)
    .setLabel('Sconto (%)')

  private amountControl = this.generalService.getTextControl({
    name: 'Amount',
    required: false,
    flexSpacePercentage: 50
  })
    .setType(CtControlTypes.NUMBER)
    .setLabel('AmountRow')

  /**
   * Hint testuale che mostra i prezzi suggeriti per l'articolo
   * Viene visualizzato sotto il campo Amount nella modale di add/edit
   * Mostra: prezzo standard e prezzo fornitore (se disponibile)
   */
  priceHint: string = '';


  private Type = this.controlService
    .getDefaultConfiguration({
      name: 'Type',
      type: CtControlTypes.ENUMERABLE,
      flexSpacePercentage: 50,
      required: false
    })
    .configureOptions<CtSelectControlOptions>(options => {

      if (!options) options = CtSelectControlOptions.create();

      options
        .setNullValueEnabled(true)
    })
    .setValueOptions([
      CtSelectControlValue.create().setLabel('Acquisto').setValue('Acquisto'),
      CtSelectControlValue.create().setLabel('Vendita').setValue('Vendita'),
      CtSelectControlValue.create().setLabel('Rivendita').setValue('Rivendita')
    ])

  private controls = [
    this.generalService.getTextControl({ name: 'Code', required: true, flexSpacePercentage: 100 }),
    this.generalService.getTextControl({ name: 'Description', required: true })
      .setType(CtControlTypes.TEXTAREA)
      .setFlexSpacePercentage(100)
      .configureOptions<CtTextareaControlOptions>(options => {

        if (!options) options = CtTextareaControlOptions.create();

        options
          .setRows(5)

      }),
    this.generalService.getTextControl({
      name: 'Quantity', required: true,
      flexSpacePercentage: 50
    })
      .setValue(1)
      .setType(CtControlTypes.NUMBER),
    this.amountControl,
    this.discountControl,
    this.vatControl,
    this.Type

  ];


  constructor(
    private cdr: ChangeDetectorRef,
    private controlService: CtControlService,
    private formBuilder: FormBuilder,
    private generalService: CTMGeneralService,
    private workOrderService: WorkOrderService,
    private managerService: CtManagerService,
    private dialogRef: MatLegacyDialogRef<MovementManagerAddItemComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) private config: MovementManagerAddItemConfiguration) {

    this.formConfiguration = CtFormConfiguration
      .create(this.formBuilder.group({}))
      .setTheme(CtThemeTypes.MATERIAL)
      .setControls(this.controls);

    if (this.config.Values) {
      this.setup(this.config.Values)
    }

  }

async ngOnInit() {
  await this.setupConfigurationControls();

  // Imposta IVA di default solo se non c'è già un valore IVA
  if (!this.config.Values?.VAT && this.config.Values?.VAT !== 0) {

    const colsWorkOrderRowsConfiguration = CTConfigurationModel.create();
    await this.managerService.getComponentOverride("workOrder", "colsWorkOrderRowsConfiguration", colsWorkOrderRowsConfiguration);

    if (colsWorkOrderRowsConfiguration.useDefaultVAT === true) {
      setTimeout(() => {
        this.formConfiguration?.form?.patchValue({ VAT: 22 });
      }, 100);
    }
  }
}

  async setupConfigurationControls() {

    const colsWorkOrderRowsConfiguration = CTConfigurationModel.create();

    await this.managerService.getComponentOverride("workOrder", "colsWorkOrderRowsConfiguration", colsWorkOrderRowsConfiguration);

    if (colsWorkOrderRowsConfiguration.cols && colsWorkOrderRowsConfiguration.cols.length > 0) {

      if (!colsWorkOrderRowsConfiguration.cols.some(col => col === 'VAT')) {
        this.vatControl.setHidden(true);
      }

      if (!colsWorkOrderRowsConfiguration.cols.some(col => col === 'Discount')) {
        this.discountControl.setHidden(true);
      }

      if (!colsWorkOrderRowsConfiguration.cols.some(col => col === 'Type')) {
        this.Type.setHidden(true);
      }
    }

  }

  ngAfterViewInit() {

    this.cdr.detectChanges();

  }

  async setup(value: CTWorkOrderRowUnionType | null) {

    if (!value) return;

    this.formConfiguration
      ?.form
      ?.patchValue(value);

    const item = (<CtWorkOrderRowItem>value).Item;

    if (item) {

      if ('Description' in item) {

        const description = this.formConfiguration?.form?.get('Description');
        description?.setValue(item?.Description);
        description?.disable();

      }

      if ('Code' in item) {

        const code = this.formConfiguration?.form?.get('Code');
        code?.setValue(item?.Code)
        code?.disable();

      }

      if (this.config.Values?.State === WorkOrderRowState.Closed) {

        const quantity = this.formConfiguration?.form?.get('Quantity');
        quantity?.disable();

      }

      this.updatePriceHint(item.Oid);


    }

  }

  onAdd() {

    if (!this.formConfiguration?.form?.valid) return;

    const value = this.formConfiguration?.form?.getRawValue();
    const values = this.config.Values;

    let row: CTWorkOrderRowUnionType;

    if ((<CtWorkOrderRowItem>values)?.Item) {

      row = CtWorkOrderRowItem.create({ Item: (<CtWorkOrderRowItem>values)?.Item, ...value });

    } else if ((<CtWorkOrderRowOffer>values)?.Offer) {

      row = CtWorkOrderRowOffer.create({ Offer: (<CtWorkOrderRowOffer>values)?.Offer, ...value });

    } else if ((<CtWorkOrderRowContact>values)?.Contact) {

      row = CtWorkOrderRowContact.create({ Contact: (<CtWorkOrderRowContact>values)?.Contact, ...value });

    } else {

      row = CTWorkOrderRow.create(value);

    }

    row
      .setWorkOrderOid(this.config.WorkOrder?.Oid ?? -1)

    if (values?.Oid) {

      row.setOid(values.Oid);

    }

    row
      .setState(values?.State ?? WorkOrderRowState.Open)
      .setOrigin(values?.Origin ?? WorkOrderRowOrigin.Standard);

    this.workOrderService
      .putRow(row)
      ?.then((response) => {

        if (response.Result && !isNaN(response?.Result)) {

          row
            .setOid(response.Result)

        }

        this.dialogRef
          .close(row)

      })

  }

  onCancel() {

    this.dialogRef
      .close();

  }

  /**
   * Aggiorna l'hint dei prezzi mostrato sotto il campo Amount
   * Recupera le informazioni dell'articolo tramite API e mostra:
   * - DefaultPrice dell'articolo
   * - Prezzo più basso tra i fornitori (se disponibili)
   *
   * @param itemOid - OID dell'articolo da cui recuperare i prezzi
   */
  private async updatePriceHint(itemOid: number | null): Promise<void> {

    const colsWorkOrderRowsConfiguration = CTConfigurationModel.create();

    await this.managerService.getComponentOverride("workOrder", "colsWorkOrderRowsConfiguration", colsWorkOrderRowsConfiguration).then((component) => {
      return;
    });


    if(!colsWorkOrderRowsConfiguration.visibleHintRowWorkOrder) return;


    // Verifica che l'itemOid sia valido
    if (!itemOid) {
      console.warn('[MovementManagerAddItem] updatePriceHint: itemOid non valido', itemOid);
      return;
    }

    // Chiamata al servizio per recuperare le informazioni dell'articolo
    this.generalService.getInfos({ controller: 'item', oid: itemOid }).subscribe({
      next: (response) => {
        // Estrazione dell'item dalla response
        const item = response?.Result?.DataSource;

        if (!item) {
          console.warn('[MovementManagerAddItem] updatePriceHint: item non trovato nella response', response);
          this.setAmountHint('');
          return;
        }

        // Recupero del prezzo di default dell'articolo
        const defaultPrice = item.DefaultPrice;

        // Recupero del prezzo più basso dai fornitori
        let lowestSupplierPrice: number | null = null;

        if (item.Suppliers && Array.isArray(item.Suppliers) && item.Suppliers.length > 0) {
          // Filtra i fornitori che hanno un DefaultBuyPrice valido e trova il minimo
          const validPrices = item.Suppliers
            .map((supplier: any) => supplier.DefaultBuyPrice)
            .filter((price: number) => price != null && price !== undefined && !isNaN(price));

          if (validPrices.length > 0) {
            lowestSupplierPrice = Math.min(...validPrices);
          }
        }

        // Costruzione dell'hint in base ai prezzi disponibili
        let hintText = '';

        // Caso 1: Entrambi i prezzi disponibili
        if (defaultPrice != null && lowestSupplierPrice != null) {
          hintText = `Prezzo articolo: €${defaultPrice} - Miglior prezzo fornitore: €${lowestSupplierPrice}`;
        }
        // Caso 2: Solo prezzo articolo disponibile
        else if (defaultPrice != null) {
          hintText = `Prezzo articolo: €${defaultPrice}`;
        }
        // Caso 3: Solo prezzo fornitore disponibile
        else if (lowestSupplierPrice != null) {
          hintText = `Miglior prezzo fornitore: €${lowestSupplierPrice}`;
        }
        // Caso 4: Nessun prezzo disponibile
        else {
          hintText = 'Nessun prezzo disponibile';
        }

        // Impostazione dell'hint sul control
        this.setAmountHint(hintText);
      },
      error: (error) => {
        console.error('[MovementManagerAddItem] updatePriceHint: errore nel recupero delle informazioni dell\'articolo', error);
        // In caso di errore, pulisco l'hint
        this.setAmountHint('');
      }
    });

  }

  /**
   * Imposta l'hint sul control Amount
   * Crea le MaterialOptions se non esistono e imposta il messaggio dell'hint
   *
   * @param message - Messaggio da mostrare nell'hint
   */
  private setAmountHint(message: string): void {
    const materialOptions = this.amountControl.materialOptions;

    if (!materialOptions) {
      this.amountControl.setMaterialOptions(MaterialControlOptions.create());
    }

    this.amountControl.materialOptions?.setHint(
      MateriaHintExtensionConfig.create().setMessage(message)
    );
  }

}
